import { useQuery } from '@apollo/client';
import { isEqual } from 'lodash';
import { Fragment, useEffect, useMemo, useState } from 'react';
import Button from '~/components/Button';
import Divider from '~/components/Divider';
import Icon from '~/components/Icon';
import StoreReviewItem from '~/components/Items/StoreReviewItem';
import Select from '~/components/Select';
import Text from '~/components/Text';
import Colors from '~/constants/colors';
import { QUERY_GET_ALL_REVIEWS } from '~/data/home';
import { ReviewItem } from '~/data/product/interfaces';

const TabReviewsShop = ({ setSummaryAllReview }: any) => {
    const [page, setPage] = useState(1);
    const [sort, setSort] = useState('rating-DESC');

    const { data, fetchMore, networkStatus, loading } = useQuery(QUERY_GET_ALL_REVIEWS, {
        variables: {
            pageSize: 4,
            sort:
                sort && sort?.split('-').length > 0
                    ? {
                          [sort?.split('-')[0]]: sort?.split('-')[1]
                      }
                    : undefined
        },
        context: { fetchOptions: { method: 'GET' } },
        notifyOnNetworkStatusChange: true
    });

    const page_info = data?.allReview?.page_info;
    useEffect(() => {
        setSummaryAllReview?.({
            summary: data?.allReview?.summary,
            summary_detail: data?.allReview?.summary_detail,
            total_count: data?.allReview?.total_count
        });
    }, [page_info]);

    const items: ReviewItem[] = useMemo(() => {
        if (loading && [1, 2].includes(networkStatus)) return Array(4).fill({});
        return data?.allReview?.items || [];
    }, [data?.allReview?.items, loading]);

    const handleShowMore = () => {
        if (networkStatus === 3) return;
        if (Number(Number(page_info?.current_page) * page) >= Number(page_info?.total_pages)) return;
        if (!!fetchMore) {
            const increasePage = page ? Number(page) + 1 : 1;
            setPage(increasePage);
            fetchMore({
                variables: {
                    currentPage: increasePage
                },
                updateQuery: (previousResult: any, { fetchMoreResult }: any) => {
                    if (!fetchMoreResult) return previousResult;
                    const newReviews = fetchMoreResult?.allReview?.items || [];
                    const nextReview = [...previousResult?.allReview?.items, ...newReviews];

                    return {
                        allReview: {
                            ...previousResult.allReview,
                            items: nextReview
                        }
                    };
                }
            });
        }
    };

    const isShowMore = networkStatus === 3 || page < Number(page_info?.total_pages);

    return (
        <div className="flex flex-col gap-2 w-full">
            <div className="w-[160px] ml-auto">
                <Select
                    className="flex-1"
                    si
                    options={[
                        { label: 'Highest Rating', value: 'rating-DESC' },
                        { label: 'Most recent', value: 'date-DESC' },
                        { label: 'Lowest Rating', value: 'rating-ASC' }
                    ]}
                    value={sort}
                    onChange={(value: string) => {
                        setSort(value);
                        setPage(1);
                    }}
                />
            </div>
            {items.map((item, index) => {
                return (
                    <Fragment key={index}>
                        <StoreReviewItem item={item} loading={loading && [1, 2].includes(networkStatus)} />
                        {index !== items.length - 1 && <Divider dividerClassName="mb-2" />}
                    </Fragment>
                );
            })}
            <div className="flex justify-center">
                {isShowMore && (
                    <Button
                        // className="w-max mx-auto flex gap-2 items-center cursor-pointer"
                        onClick={handleShowMore}
                        type="borderless"
                    >
                        <Text type="title-4" className="flex items-center justify-center" color={Colors.PRIMARY}>
                            {networkStatus === 3 ? 'Showing' : 'Show More'}
                        </Text>
                        {networkStatus === 3 ? (
                            <Icon name="status" className="animate-spin mr-2 " size={'1rem'} />
                        ) : (
                            <Icon name="arrow-square-down-2" color={Colors.PRIMARY} />
                        )}
                    </Button>
                )}
            </div>
        </div>
    );
};

export default TabReviewsShop;
